// extracted by mini-css-extract-plugin
export var aggregationCell = "_65-p";
export var aggregationRow = "_65-o";
export var borderlessSpinnerContainer = "_65-3";
export var cardLayout = "_65-6";
export var cardLayoutNoFooter = "_65-a";
export var cardLayoutPageControl = "_65-9";
export var cardLayoutWithFooter = "_65-8";
export var closeIcon = "_65-h";
export var columnHeaderSurface = "_65-d";
export var columnHeaderSurfaceDragOverlay = "_65-x";
export var columnHeaderSurfaceResizing = "_65-u";
export var contextMenuAnchor = "_65-1";
export var draggableColumnHeader = "_65-v";
export var draggableColumnHeaderOverlay = "_65-w";
export var expandIcon = "_65-i";
export var expanded = "_65-j";
export var filterDropdown = "_65-k";
export var filterDropdownDivider = "_65-f";
export var filterDropdownHeader = "_65-n";
export var filterDropdownItem = "_65-m";
export var filterDropdownModal = "_65-l _65-k";
export var filterItem = "_65-e";
export var normalCellWithAdjustableBorder = "_65-g";
export var pinButtonContainer = "_65-q";
export var pinIcon = "_65-r";
export var pinIconActive = "_65-s";
export var spinner = "_65-0";
export var spinnerContainer = "_65-2";
export var tableContainer = "_65-4";
export var tableContentDraggingColumns = "_65-c";
export var tableContentInner = "_65-7";
export var tableContentInnerFill = "_65-b";
export var tableContentWrapper = "_65-5";
export var viewButtonContainer = "_65-t";